module.exports = __webpack_public_path__ + "static/media/circle-plus-blue.dfb01604.svg";